<template>
<v-container v-if="club">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{club.name}} </div>
      </v-col>
    </v-row>
    <v-row>
    <v-col>
    <div class="pt-3"> Entradas:{{club.entry_count}} </div>
      </v-col>
      <v-col>
        <div class="pt-3">
          <a style="font-size: 20px; text-decoration: underline; color: #4cccc1" :href="'/cambios_club/'+club.id">Ver solicitudes</a>
        </div>
      </v-col>
      <v-col>
    <div class="pt-3"> Salidas:{{club.exit_count}} </div>
      </v-col>
  </v-row>
  </div>
<div>

<br>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          ID
        </th>
        <th class="text-center">
          Canon
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in club.players"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/player/'+item.id" style="color:blue">{{ item.full_name }}</a></td>
        <td class="text-left">
            {{ item.federation_id }}
        </td>
        <td class="text-left">
          <p v-if="item.canon">Pagado</p>
          <p v-else>No Pagado</p>
        </td>
      </tr>
    </tbody>
  </v-table>
  </div>
</v-container>

</template>
<script>

import {mapState} from "vuex";
import gql from "graphql-tag";
import axios from "axios";
export default {
  apollo: {
    club: {query: gql` query($id:String!){
       club:seeClub(id:$id){
        id
        name
        entry_count:entryCount
        exit_count:exitCount
        players:personSet{
          id
          full_name:fullNameEnglish
          canon
          federation_id:federationId
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  props:['id'],
    name:"SeeNewsChess",
  data() {

    return {
      a:'',
      club: null,
    }
  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {

    onChange() {
      console.log("this.conktent",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    handleStatusChange(item) {
      const url = '/update_model_inscription/';
      // Aquí puedes manejar el cambio de estado, por ejemplo, hacer una llamada API para actualizar el estado en tu servidor.
      console.log('Status changed for inscription', item.status);
      axios.post(url, item).then(() => {
        alert("cambio aplicado con exito")
      })
      .catch(error => {
        alert("datos ingresados no validos")
        console.log(error)
      })
    },
  },
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
